import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import uuid from 'uuid/v4';
import messages from './messages';

function TabHeader({ tabs, setActiveTab, activeTab, maxItem }) {
  return (
    <ul data-tabs className="tabs">
      {tabs.map((tab, index) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
        <li
          key={uuid()}
          className={`tabs ${activeTab === index ? 'active' : ''}`}
          onClick={() => {
            setActiveTab(index);
          }}
        >
          <a data-tab>
            <span className="label text-uppercase">
              <FormattedMessage
                {...messages[tab]}
                values={{ counter: maxItem }}
              />
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
}

TabHeader.defaultProps = {
  activeTab: 0,
  maxItem: 6,
  tabs: [],
};

TabHeader.propTypes = {
  setActiveTab: PropTypes.func,
  activeTab: PropTypes.number,
  tabs: PropTypes.array,
  maxItem: PropTypes.number
};

export default TabHeader;
